function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';
import Context from "../context";
import translator from "./";
import security from "../security";
import logger from "../logger";
import AutosizeInput from 'react-input-autosize';
import dom from "../utils/dom";

var Translation = /*#__PURE__*/function (_React$Component) {
  _inherits(Translation, _React$Component);

  var _super = _createSuper(Translation);

  function Translation() {
    var _this;

    _classCallCheck(this, Translation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      focus: false,
      value: null,
      submitting: false
    });

    return _this;
  }

  _createClass(Translation, [{
    key: "locale",
    get:
    /**
     * Get current locale
     *
     * @return {string}
     */
    function get() {
      var locale = this.context.locale;
      return locale;
    }
    /**
     * Get translation value
     *
     * @return {string}
     */

  }, {
    key: "translation",
    get: function get() {
      var _this$props = this.props,
          children = _this$props.children,
          number = _this$props.number;
      return translator.translate(children, number, this.locale);
    }
    /**
     * Get input style configured with inherited css properties
     *
     * @return {object}
     */

  }, {
    key: "inputStyle",
    get: function get() {
      return {
        background: 'transparent',
        border: 'none',
        padding: 0,
        margin: 0,
        fontSize: dom.getStyle(this.container, 'font-size'),
        letterSpacing: dom.getStyle(this.container, 'letter-spacing'),
        color: dom.getStyle(this.container, 'color'),
        fontWeight: dom.getStyle(this.container, 'font-weight')
      };
    }
    /**
     * Disable edition mode (show only translation, no input)
     */

  }, {
    key: "disableEdition",
    value: function disableEdition() {
      this.setState({
        focus: false,
        value: null,
        submitting: false
      });
    }
    /**
     * Enable edition mode (show input)
     */

  }, {
    key: "enableEdition",
    value: function enableEdition() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          number = _this$props2.number;
      var translation = translator.getTranslation(children, this.locale);
      var value = children;

      if (translation) {
        value = translation[number > 1 ? 'pluralValue' : 'value'];
      }

      this.setState({
        focus: true,
        value: value
      }, function () {
        return _this2.input && _this2.input.focus();
      });
    }
    /**
     * Sync managed translation with current value of input
     */

  }, {
    key: "submit",
    value: function submit() {
      var _this3 = this;

      this.setState({
        submitting: true
      }, function () {
        var _this3$props = _this3.props,
            children = _this3$props.children,
            number = _this3$props.number;
        var value = _this3.state.value;
        translator.sync(children, value, _this3.locale, number > 1).then(function () {
          return _this3.disableEdition();
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$translation,
          _this4 = this;

      var _this$state = this.state,
          focus = _this$state.focus,
          value = _this$state.value,
          submitting = _this$state.submitting;
      var editionMode = this.context.editionMode;
      var canUserEditTranslation = security.hasPermissions({
        Translation: ['update']
      }) && !editionMode;

      if (this.translation && (_this$translation = this.translation) !== null && _this$translation !== void 0 && _this$translation.value && this.translation.value !== 'string') {
        if (this.translation[this.locale]) {
          return /*#__PURE__*/React.createElement("span", {
            className: "translation-content"
          }, this.translation[this.locale]);
        }

        return null;
      }

      return canUserEditTranslation ? this.translation : /*#__PURE__*/React.createElement("span", {
        ref: function ref(el) {
          _this4.container = el;
        },
        onContextMenu: function onContextMenu(e) {
          e.preventDefault();
          e.stopPropagation();

          _this4.enableEdition();
        }
      }, !focus ? this.translation : /*#__PURE__*/React.createElement(AutosizeInput, {
        ref: function ref(el) {
          _this4.input = el;
        },
        disabled: submitting,
        inputStyle: this.inputStyle,
        value: value || '',
        onChange: function onChange(e) {
          return _this4.setState({
            value: e.target.value
          });
        },
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onBlur: this.disableEdition,
        onKeyUp: function onKeyUp(e) {
          // Stop event diffusion to avoid button click event when press backspace
          e.preventDefault();
          e.stopPropagation();

          if (e.key === 'Enter') {
            _this4.submit();
          }
        }
      }), submitting && /*#__PURE__*/React.createElement(Spinner, {
        className: "ml-2",
        size: "sm"
      }));
    }
  }]);

  return Translation;
}(React.Component);

Translation.contextType = Context;
Translation.propTypes = {
  children: PropTypes.string.isRequired,
  // key
  number: PropTypes.number
};
Translation.defaultProps = {
  number: null
};
export default Translation;